"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBucketInventoryConfigurationsInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContinuationToken: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "continuation-token"
        }
    }
};
//# sourceMappingURL=ListBucketInventoryConfigurationsInput.js.map